import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/shop", label: "Shop" },
  { to: "/shop?category=Outerwear", label: "Outerwear" },
];

export default function Navbar() {
  const { count, setOpen } = useCart();
  const { user, isAdmin, logout } = useAuth();
  const [mobile, setMobile] = useState(false);
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-border">
      <div className="max-w-[1500px] mx-auto px-5 sm:px-8 flex items-center justify-between h-16">
        <Link to="/" data-testid="logo-link" className="font-heading font-black text-2xl tracking-tighter uppercase">
          Bundles and Blends<span className="text-accent">.</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <Link key={l.label} to={l.to} data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-xs font-bold tracking-[0.18em] uppercase hover:text-accent transition-colors">
              {l.label}
            </Link>
          ))}
          {isAdmin && (
            <Link to="/admin" data-testid="nav-admin" className="text-xs font-bold tracking-[0.18em] uppercase text-accent hover:opacity-70 transition-opacity">Admin</Link>
          )}
        </nav>

        <div className="flex items-center gap-4">
          {user ? (
            <button onClick={() => { logout(); navigate("/"); }} data-testid="logout-button"
              className="hidden sm:flex items-center gap-1.5 text-xs font-bold tracking-[0.15em] uppercase hover:text-accent transition-colors">
              <User size={16} /> Logout
            </button>
          ) : (
            <Link to="/login" data-testid="login-link"
              className="hidden sm:flex items-center gap-1.5 text-xs font-bold tracking-[0.15em] uppercase hover:text-accent transition-colors">
              <User size={16} /> Account
            </Link>
          )}
          <button onClick={() => setOpen(true)} data-testid="cart-button" className="relative p-1 hover:text-accent transition-colors">
            <ShoppingBag size={20} />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-1.5 -right-1.5 bg-accent text-accent-foreground text-[10px] font-bold w-4 h-4 flex items-center justify-center">
                {count}
              </span>
            )}
          </button>
          <button onClick={() => setMobile(!mobile)} data-testid="mobile-menu-toggle" className="md:hidden p-1">
            {mobile ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {mobile && (
        <div className="md:hidden border-t border-border bg-white px-5 py-4 flex flex-col gap-4">
          {links.map((l) => (
            <Link key={l.label} to={l.to} onClick={() => setMobile(false)}
              className="text-sm font-bold tracking-[0.15em] uppercase">{l.label}</Link>
          ))}
          {isAdmin && <Link to="/admin" onClick={() => setMobile(false)} className="text-sm font-bold tracking-[0.15em] uppercase text-accent">Admin</Link>}
          {user ? (
            <button onClick={() => { logout(); setMobile(false); navigate("/"); }} className="text-left text-sm font-bold tracking-[0.15em] uppercase">Logout</button>
          ) : (
            <Link to="/login" onClick={() => setMobile(false)} className="text-sm font-bold tracking-[0.15em] uppercase">Account</Link>
          )}
        </div>
      )}
    </header>
  );
}
